/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/anchor-has-content */

import React from 'react';

const NavigationDots = ({ active }) => (
  <div className="app__navigation small-screen">
    {['home', 'work', 'experience', 'articles', 'reviews', 'contact'].map((item, index) => (
      <a
        href={`#${item}`}
        key={item + index}
        className={`app__navigation-dot ${active === item ? 'active' : ''}`}
      />
    ))}
  </div>
);

export default NavigationDots;